const sortUploads = (uploads) => {
  const mediaTypePhotoList = {
    MEDIA_TYPE_PHOTO_DAMAGE: 1,
    MEDIA_TYPE_PHOTO_ACCIDENT_SCENE: 2,
    MEDIA_TYPE_PHOTO_DURING_REPAIR: 3,
    MEDIA_TYPE_PHOTO_AFTER_REPAIR: 4,
  };

  const compare = (upload) => {
    const mediaTypeCode = upload.mediaType?.code || null;
    const parentCode = upload.mediaType?.parent?.code || null;
    if (!upload.mediaType) {
      return 0;
    }
    if (parentCode  === 'MEDIA_TYPE_DOCUMENT') {
      return 1;
    }
    if (parentCode === 'MEDIA_TYPE_PHOTO') {
      if (mediaTypeCode in mediaTypePhotoList) {
        return 2 + mediaTypePhotoList[mediaTypeCode];
      } else {
        return 2 + Object.keys(mediaTypePhotoList).length + 1;
      }
    }

    return -1;
  };

  return [...uploads].sort((firstUpload, secondUpload) => {
    const firstCompare = compare(firstUpload);
    const secondCompare = compare(secondUpload);

    if (firstCompare === 1 && firstCompare === secondCompare) {
      return firstUpload.mediaType?.name.localeCompare(secondUpload.mediaType?.name);
    }

    return firstCompare - secondCompare;

  });
};

export const preserveUploadOrder = (currentUploads, nextUploads, getUploadId) => {
  const nextUploadsById = new Map(
    nextUploads.map((upload) => [getUploadId(upload), upload]),
  );
  const orderedUploads = currentUploads
    .map((upload) => nextUploadsById.get(getUploadId(upload)))
    .filter(Boolean);
  const orderedUploadIds = new Set(orderedUploads.map((upload) => getUploadId(upload)));
  const newUploads = sortUploads(
    nextUploads.filter((upload) => !orderedUploadIds.has(getUploadId(upload))),
  );

  return [...orderedUploads, ...newUploads];
};

export default sortUploads;
